import React, { useState, useEffect } from "react";
import api from "../../api.js";
import Loading from "../../components/loading/loading.js";
import ReactPaginate from "react-paginate";
import NavBar from "../../components/menu.jsx";
import "./clientes.css";
import CryptoJS from "crypto-js";
import toastr from "toastr";

function Agenda() {
  const [cliente, setCliente] = useState([]);
  const [nome, setNome] = useState(" ");
  const [pagina, setPagina] = useState(1);
  const [nomePessoa, setNomePessoa] = useState(" ");
  const [pageCount, setpageCount] = useState(1);
  const datas = new Date();
  const [controle, setControle] = useState(0);
  const [tipoConsulta, setTipoConsulta] = useState("Codigo");

  function encryptData(value) {
    return CryptoJS.AES.encrypt(value.toString(), "AFM-Distrato").toString();
  }

  function decryptData(encryptedData) {
    const bytes = CryptoJS.AES.decrypt(
      encryptedData.toString(),
      "AFM-Distrato"
    );
    return bytes.toString(CryptoJS.enc.Utf8);
  }

  useEffect(() => {
    Loading.show("Aguarde....");
    const fetchGetList = async () => {
      const res = await api.get(
        `/listarDadosDistrato/?page=${pagina}&pageSize=10`
      );
      setCliente(res.data.DATA);
      const total = Number(res.data.TOTALPAGES);
      setpageCount(Math.ceil(total));
      Loading.hide();
    };
    fetchGetList();
    // eslint-disable-next-line
  }, [controle]);

  const handlePageClick = async (data) => {
    let currentPage = data.selected + 1;
    setPagina(currentPage);
    setControle(controle + 1);
  };

  function alterarNome(event) {
    setNome(event.target.value);
  }

  function alterarNomeP(event) {
    setNomePessoa(event.target.value);

    if (nomePessoa == "") {
      setNome(" ");
    }
  }

  function Buscar(tipoConsulta) {
    if (document.getElementById("campoBusca").value.trim() === "") {
      Loading.show("Aguarde....");
      const fetchGetList = async () => {
        const res = await api.get(
          `/listarDadosDistrato/?page=${pagina}&pageSize=10`
        );
        setCliente(res.data.DATA);
        const total = Number(res.data.TOTALPAGES);
        setpageCount(Math.ceil(total));
        Loading.hide();
      };
      fetchGetList();
    } else {
      if (tipoConsulta === "Nome") {
        Loading.show("Aguarde....");
        const fetchGetList = async () => {
          const res = await api.get(
            `/listarDadosDistrato/Nome/?page=1&pageSize=10&name=${nome}`
          );
          setCliente(res.data.DATA);
          const total = Number(res.data.TOTALPAGES);
          setpageCount(Math.ceil(total));
          Loading.hide();
        };
        fetchGetList();
        // eslint-disable-next-line
      } else {
        Loading.show("Aguarde....");
        const fetchGetList = async () => {
          const res = await api.get(
            `/listarDadosDistrato/Id/?page=1&pageSize=10&id=${nome}`
          );
          setCliente(res.data.DATA);
          const total = Number(res.data.TOTALPAGES);
          setpageCount(Math.ceil(total));
          Loading.hide();
        };
        fetchGetList();
        // eslint-disable-next-line
      }
    }
  }

  const openPdfInNewWindow = (id) => {
    Loading.show("Aguarde....");
    api
      .get(`/distratoPdf?id=${id}`)
      .then(function (AxiosResponse) {
        Loading.hide();
        const pdfBase64 = AxiosResponse.data;
        const width = 800;
        const height = 600;
        const left = window.screen.width / 2 - width / 2;
        const top = window.screen.height / 2 - height / 2;
        const windowFeatures = `width=${width},height=${height},left=${left},top=${top}`;
        const pdfWindow = window.open("", "_blank", windowFeatures);
        pdfWindow.document.write(`<style>
                                  body, html { 
                                    margin: 0;
                                    padding: 0;
                                    overflow: hidden;}
                                  iframe {border: none;}
                                </style>
            <iframe width='100%' height='100%'  src='data:application/pdf;base64,${pdfBase64}'></iframe>`);
      })
      .catch(function (error) {
        Loading.hide();
        toastr.error(error, "Erro ao buscar pdf.");
      });
  };

  const type =
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
      ? "cardMobileHome"
      : "cardWebHome";

  return (
    <div className="fundo">
      <NavBar />
      <div className="container-fluid">
        <div className={`card ${type} pt-3 ps-2 pe-2 mt-3 w-100`}>
          <div className="text-center">
            <h3 className="tituloD mb-1">Clientes Distrato</h3>
          </div>
          <div className="row  container-fluid">
            <div className="col-md-4">
              <label for="inputZip">
                {tipoConsulta === "Nome" ? "Nome Cliente" : "Código Cálculo"}
              </label>
              <input
                type="text"
                className="form-control"
                id="campoBusca"
                onChange={(e) => setNome(e.target.value)}
                placeholder={
                  tipoConsulta === "Nome"
                    ? "Digite o nome para buscar..."
                    : "Digite o código para buscar..."
                }
                aria-describedby="button-addon2"
              />
            </div>
            <div className="col-md-2 text-start">
              {/* <b className="labelDesc">Filtro</b> */}
              <label for="inputZip">Filtro</label>
              <select
                class="form-select"
                id="selectParentesco"
                onChange={(e) => setTipoConsulta(e.target.value)}
              >
                <option value="Codigo" selected>
                  Código
                </option>
                <option value="Nome">Nome</option>
              </select>
            </div>

            <div className="col-md-2 mt-3">
              <button
                onClick={() => Buscar(tipoConsulta)}
                className="btn btn-outline-success btn-sm w-100"
                type="button"
                id="button-addon2"
              >
                Buscar
              </button>
            </div>
          </div>
          <div className="row mt-3 container-fluid">
            <div className="col-md-12">
              <table className="table table-responsive table-sm table-striped noborder table-borderless w-100">
                <thead>
                  <tr className="tabela">
                    <th className="codigo text-center" scope="col">
                      {" "}
                      Código
                    </th>
                    <th className="data text-center" scope="col">
                      Dt. Cálculo
                    </th>
                    <th className="data text-center" scope="col">
                      Dt. Contrato
                    </th>
                    <th className="cliente" scope="col">
                      Nome
                    </th>
                    <th className="data text-center" scope="col">
                      Telefone
                    </th>
                    <th className="calculo text-end" scope="col">
                      Montante Restituível
                    </th>
                    <th className="data text-end" scope="col">
                      Diferença dos Cálculos
                    </th>
                    <th className="data text-center" scope="col">
                      Tipo Cálculo
                    </th>
                    <th className="editar" scope="col"></th>
                  </tr>
                </thead>
                <tbody className="">
                  {cliente?.map((cli) => (
                    <tr key={cli.id_calculo_distrato}>
                      <td className="text-center">{cli.id_calculo_distrato}</td>
                      <td className="text-center">
                        {new Date(cli.data_calculo).toLocaleDateString("pt-BR")}
                      </td>
                      <td className="text-center">
                        {new Date(cli.data_contrato).toLocaleDateString(
                          "pt-BR"
                        )}
                      </td>
                      <td>{cli.nome + " " + cli.sobrenome}</td>
                      <td className="text-center">{cli.celular}</td>

                      <td className="text-end">
                        {Number(cli.saldo_revisao).toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })}
                      </td>
                      <td className="text-end">
                        {Number(cli.valor_calculo).toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })}
                      </td>
                      <td className="text-center">{cli.tipo_calculo}</td>
                      <td className="text-center">
                        <img
                          src="../../../img/imprimir.png"
                          onClick={() => {
                            openPdfInNewWindow(cli.id_calculo_distrato);
                          }}
                          alt=""
                          width="25"
                          className="fas mouse fa-edit icone-acao"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <ReactPaginate
              previousLabel={"<"}
              nextLabel={">"}
              breakLabel={"..."}
              pageCount={pageCount}
              marginPagesDisplayed={3}
              pageRangeDisplayed={3}
              onPageChange={handlePageClick}
              containerClassName={"pagination justify-content-center"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
              activeClassName={"active"}
              disableInitialCallback={true}
              style={{ outline: "none" }}
            />
          </div>
        </div>
      </div>

      {/* Modal Agendamento */}
      <div
        className="modal fade modal-lg"
        id="modalAgendamento"
        data-bs-backdrop="false"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="false"
      >
        <div className="opaco">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <div className="row">
                  <h5
                    className="modal-title col-md-12 tituloC"
                    id="TituloModalLongoExemplo"
                  >
                    Família
                  </h5>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <table className="table table-responsive table-sm table-striped noborder table-borderless w-100">
                  <thead>
                    <tr className="tabela">
                      <th className="cliente" scope="col">
                        Nome
                      </th>
                      <th className="telefone" scope="col">
                        Parentesco
                      </th>
                      <th className="RendaFamilia" scope="col">
                        Renda
                      </th>
                    </tr>
                  </thead>
                  <tbody className="text-center">
                    {/*{familia?.map((cli) => (
                      <tr key={cli.id_cauculo_bpc_familia}>
                        <td>{cli.nome}</td>
                        <td>{cli.parentesco}</td>
                        <td>R$: {Mask.dinheiro(cli.renda)}</td>
                      </tr>
                    ))}*/}
                  </tbody>
                </table>
              </div>
              <div className="modal-footer">
                {/* <button onClick={() => SalvarCadastro()} type="button" className="btn btn-success">Salvar</button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Agenda;
